var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 15C25.7812 15 24.375 16.4062 24.375 18.125V61.875C24.375 63.5938 25.7812 65 27.5 65H58.75C60.4688 65 61.875 63.5938 61.875 61.875V27.5L49.375 15H27.5Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 27.5H61.875L49.375 15V24.375C49.375 26.0938 50.7812 27.5 52.5 27.5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.875 36.875L52.5 27.5H61.875V36.875Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.625 55.625C55.625 56.4844 54.9219 57.1875 54.0625 57.1875H19.6875C18.8281 57.1875 18.125 56.4844 18.125 55.625V40C18.125 39.1406 18.8281 38.4375 19.6875 38.4375H54.0625C54.9219 38.4375 55.625 39.1406 55.625 40V55.625Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9375 44.6047C24.9375 44.1922 25.2625 43.7422 25.7859 43.7422H28.6719C30.2969 43.7422 31.7594 44.8297 31.7594 46.9141C31.7594 48.8891 30.2969 49.9891 28.6719 49.9891H26.5859V51.6391C26.5859 52.1891 26.2359 52.5 25.7859 52.5C25.3734 52.5 24.9375 52.1891 24.9375 51.6391V44.6047ZM26.5859 45.3156V48.4281H28.6719C29.5094 48.4281 30.1719 47.6891 30.1719 46.9141C30.1719 46.0406 29.5094 45.3156 28.6719 45.3156H26.5859Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2063 52.4969C33.7938 52.4969 33.3438 52.2719 33.3438 51.7234V44.6266C33.3438 44.1781 33.7938 43.8516 34.2063 43.8516H37.0672C42.7766 43.8516 42.6516 52.4969 37.1797 52.4969H34.2063ZM34.9937 45.3766V50.9734H37.0672C40.4406 50.9734 40.5906 45.3766 37.0672 45.3766H34.9937Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6734 45.4781V47.4641H47.8594C48.3094 47.4641 48.7594 47.9141 48.7594 48.35C48.7594 48.7625 48.3094 49.1 47.8594 49.1H44.6734V51.7234C44.6734 52.1609 44.3625 52.4969 43.925 52.4969C43.375 52.4969 43.0391 52.1609 43.0391 51.7234V44.6266C43.0391 44.1781 43.3766 43.8516 43.925 43.8516H48.3109C48.8609 43.8516 49.1859 44.1781 49.1859 44.6266C49.1859 45.0266 48.8609 45.4766 48.3109 45.4766H44.6734V45.4781Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0625 57.1875H24.375V58.75H54.0625C54.9219 58.75 55.625 58.0469 55.625 57.1875V55.625C55.625 56.4844 54.9219 57.1875 54.0625 57.1875Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfView);
export default __webpack_public_path__ + "static/media/PdfView.406302a1acb31e532cf38d9a5b57fd5f.svg";
export { ForwardRef as ReactComponent };